import { HatElement } from '@/components/hat-element.js';

interface ServiceMeta {
    service: string;
    desc?: string;
    lang?: string;
    langVer?: string;
    version?: string;
    error?: string;
}

class HatAdminServices extends HatElement {
    private _services: ServiceMeta[] = [];
    private _loading = true;

    connectedCallback() {
    super.connectedCallback();
    this._renderShell();
        this._load();
    }

    async _load() {
        try {
            const res = await fetch('/api/service-meta');
            this._services = await res.json();
        } catch {
            this._services = [];
        }
        this._loading = false;
        this._renderContent();
    }

    _renderShell() {
        this.root.innerHTML = `
            <style>
                h2 {
                    color: white;
                    font-size: 1.4rem;
                    margin: 0 0 20px;
                    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    background: white;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                }

                th {
                    background: #f8f8f8;
                    text-align: left;
                    padding: 12px 16px;
                    font-size: 0.78rem;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    color: #666;
                    border-bottom: 1px solid #eee;
                }

                td {
                    padding: 12px 16px;
                    border-bottom: 1px solid #f0f0f0;
                    font-size: 0.9rem;
                    vertical-align: middle;
                }

                tr:last-child td { border-bottom: none; }

                .service-name { font-weight: 600; }

                .desc { color: #555; font-size: 0.85rem; }

                .badge {
                    display: inline-block;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 0.78rem;
                    font-weight: 600;
                }

                .badge-ok    { background: #d1fae5; color: #065f46; }
                .badge-error { background: #fee2e2; color: #991b1b; }

                .version { font-family: monospace; font-size: 0.88rem; }

                .loading {
                    text-align: center;
                    padding: 40px;
                    color: rgba(255,255,255,0.7);
                }

                .error-msg { color: #991b1b; font-size: 0.85rem; }
            </style>

            <h2>Services</h2>
            <div id="content"><p class="loading">Loading…</p></div>
        `;
    }

    _renderContent() {
        const content = this.root.getElementById('content');
        if (!content) return;

        if (this._services.length === 0) {
            content.innerHTML = `<p class="loading">No data.</p>`;
            return;
        }

        const rows = this._services.map(s => {
            if (s.error) {
                return `
                    <tr>
                        <td class="service-name">${s.service}</td>
                        <td colspan="3" class="error-msg">${s.error}</td>
                        <td><span class="badge badge-error">Error</span></td>
                    </tr>
                `;
            }
            const runtime = s.lang && s.langVer ? `${s.lang} ${s.langVer}` : (s.lang ?? '—');
            return `
                <tr>
                    <td class="service-name">${s.service}</td>
                    <td class="desc">${s.desc ?? '—'}</td>
                    <td>${runtime}</td>
                    <td class="version">${s.version ?? '—'}</td>
                    <td><span class="badge badge-ok">OK</span></td>
                </tr>
            `;
        }).join('');

        content.innerHTML = `
            <table>
                <thead>
                    <tr>
                        <th>Service</th>
                        <th>Description</th>
                        <th>Runtime</th>
                        <th>Version</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>${rows}</tbody>
            </table>
        `;
    }
}

customElements.define('hat-admin-services', HatAdminServices);